import Vue from 'vue'
import Vuex from 'vuex'

import authModule from './modules/auth'
import venueModule from './modules/venue'
import eventModule from './modules/event'
import inventoryModule from './modules/inventory'
import layoutSectionsModule from './modules/layoutSections'
import dateModule from './modules/date'
import userModule from './modules/user'
import attributionIdModule from './modules/attributionId'
import microSiteConfigModule from './modules/microSiteConfig'
import daySettingsModule from './modules/daySettings'
import membershipModule from './modules/membership'
import innerIframeModule from './modules/innerIframe'
import checkoutModule from './modules/checkout'
import topBarNotificationsModule from './modules/topBarNotifications'
import configModule from './modules/config'
import miniToastsModule from './modules/miniToasts'
import orderFiltersModule from './modules/orderFilters'
import integrationModule from './modules/integration'
import chatAppModule from './modules/chatApp'
import chatModule from './modules/chat'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth: authModule,
    venue: venueModule,
    event: eventModule,
    inventory: inventoryModule,
    layoutSections: layoutSectionsModule,
    date: dateModule,
    user: userModule,
    attributionId: attributionIdModule,
    microSiteConfig: microSiteConfigModule,
    daySettings: daySettingsModule,
    membership: membershipModule,
    innerIframe: innerIframeModule,
    checkout: checkoutModule,
    topBarNotifications: topBarNotificationsModule,
    config: configModule,
    miniToasts: miniToastsModule,
    orderFilters: orderFiltersModule,
    integration: integrationModule,
    chatApp: chatAppModule,
    chat: chatModule,
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js